import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    arrowHead: {},
  },
  { name: 'arrowHeadWithTimesIcon' },
);
